import React from "react";
import { pretty } from "@/lib/residentApi";
import { Checkbox } from "@/components/ui/checkbox";
import { OpenResidentButton } from "@/components/nds/OpenResidentButton";

const TH = "px-2 py-2 text-left font-mono text-[9px] tracking-[0.18em] uppercase text-nex-muted";

export function ContactTable({ rows, selected, toggle, allOn, toggleAll }) {
  return (
    <div className="border border-white/10 rounded-sm overflow-x-auto max-h-[380px] overflow-y-auto" data-testid="contacts-table">
      <table className="w-full text-sm min-w-[640px]">
        <thead className="sticky top-0 bg-[#0b1426] z-10">
          <tr>
            <th className="px-2 py-2 w-8"><Checkbox checked={allOn} onCheckedChange={toggleAll} data-testid="contacts-select-all" aria-label="Select all" /></th>
            {["Name", "Date of Birth", "Phone", "Property", "Status"].map((h) => <th key={h} className={TH}>{h}</th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-white/5">
          {rows.map((r) => {
            const miss = !r.phone || !r.dob;
            return (
              <tr key={r.id} data-testid={`contacts-row-${r.id}`} data-missing={miss ? "true" : "false"} className={`transition-colors ${miss ? "bg-amber-500/[0.07]" : "hover:bg-white/[0.03]"}`}>
                <td className="px-2 py-1.5"><Checkbox checked={selected.has(r.id)} onCheckedChange={() => toggle(r.id)} data-testid={`contacts-check-${r.id}`} aria-label={`Select ${r.name}`} /></td>
                <td className="px-2 py-1.5 text-nex-silver"><span className="inline-flex items-center gap-2">{r.name || "—"}<OpenResidentButton residentId={r.id} name={r.name} testid={`contacts-open-${r.id}`} /></span></td>
                <td className={`px-2 py-1.5 font-mono text-xs ${r.dob ? "text-nex-silver" : "text-amber-300/70"}`} data-testid={`contacts-dob-${r.id}`}>{r.dob || "missing"}</td>
                <td className={`px-2 py-1.5 font-mono text-xs ${r.phone ? "text-nex-silver" : "text-amber-300/70"}`} data-testid={`contacts-phone-${r.id}`}>{r.phone || "missing"}</td>
                <td className="px-2 py-1.5 text-xs text-nex-muted" data-testid={`contacts-property-${r.id}`}>{r.property}</td>
                <td className="px-2 py-1.5 text-xs text-nex-muted" data-testid={`contacts-status-${r.id}`}>{pretty(r.status)}</td>
              </tr>
            );
          })}
          {!rows.length && <tr><td colSpan={6} className="px-3 py-6 text-center text-xs text-nex-muted" data-testid="contacts-empty">No residents match these filters.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

const Line = ({ list, what, id }) => list.length > 0 && (
  <div data-testid={`contacts-missing-${id}`} className="flex flex-wrap items-center gap-x-2 gap-y-1">
    <span className="text-amber-300">{list.length} resident{list.length === 1 ? " is" : "s are"} missing a {what}:</span>
    {list.map((r) => <span key={r.id} className="inline-flex items-center gap-1 text-nex-silver">{r.name}<OpenResidentButton residentId={r.id} name={r.name} testid={`contacts-missing-${id}-open-${r.id}`} /></span>)}
  </div>
);

export function MissingNote({ rows }) {
  const noPhone = rows.filter((r) => !r.phone);
  const noDob = rows.filter((r) => !r.dob);
  if (!noPhone.length && !noDob.length) return null;
  return (
    <div className="text-xs border border-amber-400/20 bg-amber-500/[0.05] rounded-sm px-3 py-2 space-y-1.5" data-testid="contacts-missing-note">
      <Line list={noPhone} what="phone number" id="phone" />
      <Line list={noDob} what="date of birth" id="dob" />
      <div className="text-nex-muted">Missing details never block the download. Those cells stay empty.</div>
    </div>
  );
}
